import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function Hero() {
  return (
    <section style={section} className="empi-section-tight">
      <div style={container} className="empi-hero-grid">
        <div style={contentColumn}>
          <div style={eyebrow}>EmPi</div>

          <h1 style={h1} className="empi-hero-title">
            Your Body Is Intelligent. Build With It.
          </h1>

          <p style={lead} className="empi-body-large">
            A daily AI guide that helps women align food, energy, and movement
            with their cycle — built for real life, not perfect routines.
          </p>

          <p style={subLead} className="empi-body-large">
            Stop forcing every day to feel the same. EmPi helps you make small
            adjustments that fit your body’s rhythm.
          </p>

          <div style={buttonRow} className="empi-button-row">
            <a href="#how" style={btnPrimary}>
              How it Works
            </a>
            <a href="#waitlist" style={btnSecondary}>
              Pilot Status
            </a>
          </div>

          <p style={note}>First pilot complete • Next phase in development</p>
        </div>

        <div style={visualShell} aria-hidden="true">
          <div style={briefCard}>
            <div style={briefEyebrow}>Today’s EmPi Brief</div>

            <div style={briefTitle}>Day 25 • Lower-energy phase</div>

            <div style={briefMeta}>Energy: slightly low</div>

            <div style={briefLabel}>Based on your rhythm today:</div>

            <div style={briefBody}>
              Since you woke up slightly low in energy, a warm protein-focused
              breakfast may feel more stabilizing this morning.
            </div>

            <div style={briefOptions}>
              <div style={briefOptionsTitle}>Options</div>
              <div>• Eggs + greens</div>
              <div>• Yogurt + nuts</div>
              <div>• Oats + seeds</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const section = {
  padding: "84px 20px 44px",
  background: empiTheme.colors.background,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "1.2fr 0.8fr",
  gap: 32,
  alignItems: "center",
};

const contentColumn = {
  maxWidth: 720,
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h1 = {
  fontSize: empiTheme.typography.h1.fontSize,
  lineHeight: 1.04,
  letterSpacing: -1,
  margin: "0 0 16px",
  color: empiTheme.colors.text,
};

const lead = {
  fontSize: 20,
  lineHeight: 1.65,
  margin: "0 0 12px",
  color: empiTheme.colors.text,
};

const subLead = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: 1.65,
  margin: "0 0 20px",
  color: empiTheme.colors.textSecondary,
};

const buttonRow = {
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
};

const note = {
  marginTop: 16,
  fontSize: 13,
  color: empiTheme.colors.textSecondary,
};

const btnBase = {
  display: "inline-block",
  textDecoration: "none",
  padding: "12px 14px",
  borderRadius: 12,
  fontWeight: 600,
  fontSize: 14,
  transition: "all 0.2s ease",
};

const btnPrimary = {
  ...btnBase,
  background: "linear-gradient(180deg, #F8C9B6 0%, #F4A98A 100%)",
  color: "#3A2A24",
  border: "1px solid #F2B79D",
  boxShadow: "0 6px 14px rgba(244, 169, 138, 0.28)",
};

const btnSecondary = {
  ...btnBase,
  background: "linear-gradient(180deg, #FFFFFF 0%, #F7F1EE 100%)",
  color: empiTheme.colors.text,
  border: "1px solid #E8D8D1",
  boxShadow: "0 5px 12px rgba(120, 90, 80, 0.10)",
};

const visualShell = {
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: 24,
  minHeight: 280,
  padding: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
  boxShadow: "0 12px 30px rgba(0, 0, 0, 0.04)",
};

const briefCard = {
  background: "#FAFAFA",
  borderRadius: empiTheme.radius.card,
  padding: 20,
  width: "100%",
  maxWidth: 340,
  border: `1px solid ${empiTheme.colors.border}`,
  boxShadow: empiTheme.shadow.card,
};

const briefEyebrow = {
  fontSize: 12,
  color: empiTheme.colors.textSecondary,
  marginBottom: 6,
};

const briefTitle = {
  fontWeight: 600,
  color: empiTheme.colors.text,
  marginBottom: 6,
};

const briefMeta = {
  fontSize: 13,
  color: empiTheme.colors.textSecondary,
  marginBottom: 14,
};

const briefLabel = {
  fontSize: 13,
  color: empiTheme.colors.textSecondary,
  marginBottom: 8,
};

const briefBody = {
  fontSize: empiTheme.typography.small.fontSize,
  lineHeight: 1.55,
  color: empiTheme.colors.text,
  marginBottom: 12,
};

const briefOptions = {
  borderTop: `1px solid ${empiTheme.colors.border}`,
  paddingTop: 10,
  fontSize: 13,
  lineHeight: 1.6,
  color: empiTheme.colors.text,
};

const briefOptionsTitle = {
  marginBottom: 6,
  color: empiTheme.colors.textSecondary,
};
